export default __webpack_public_path__ + "924089980a1775eb4dbddc1445b256ad.png";